import React from 'react';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import ActiveFilter from '../components/ActiveFilter';
import { TagItem } from '../styled';

const getActiveFilter = (
    queryKey: FiltersParams,
    filter: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    if (!filter) {
        return null;
    }

    return (
        <TagItem key={`filter-${queryKey}-${filter}`}>
            <ActiveFilter
                onClick={() => removeFilter([[queryKey, filter]])}
                filter={filter}
                queryKey={queryKey}
            />
        </TagItem>
    );
};

export default getActiveFilter;
